module.exports = __webpack_public_path__ + "fonts/Mangal Regular.f2ad400e.ttf";